import get from 'lodash/get';
import hasActionOrTimerConnection from './validateActionOrTimerConnection';

function validateGradeEffectNodes(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];
  const gradeEffectNodes = nodeInfo.effectNodes.filter(
    (node) => get(node, 'data.effect.type') === 'GRADING',
  );
  if (gradeEffectNodes.length) {
    gradeEffectNodes.forEach(effectNode => {
      if (!hasActionOrTimerConnection(effectNode, nodeInfo.nodeMap)) {
        errors.push({
          message: 'Grading effect must have action or initial timer in input chain',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: effectNode.id,
          metadata: {
            nodeId: effectNode.id,
          },
        });
      }
      if (!effectNode.data.effect.label) {
        errors.push({
          message: 'Grading effect must have name',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: effectNode.id,
          metadata: {
            nodeId: effectNode.id,
          },
        });
      }
    });
  }
  return {
    errors,
    warnings,
  };
}

export default validateGradeEffectNodes;